import React from 'react';

import { DoublesRankingPopupContainer } from '../DoublesRankingPopupContainer';
import { AuctionInformationTooltipContainer } from './AuctionInformationTooltipContainer';
import { AuctionReduceBetModalContainer } from './AuctionReduceBetModalContainer';
import { PublicationDateContainer } from './PublicationDateContainer';
import { VASListContainer } from './VASListContainer';

export function VASContainer() {
  return (
    <>
      <PublicationDateContainer />
      <VASListContainer />
      <AuctionInformationTooltipContainer />
      <AuctionReduceBetModalContainer />
      <DoublesRankingPopupContainer />
    </>
  );
}
